/* Sami Jewels PDP: normalize legacy "DETAILS" description markup into real bullets.
 * Presentation-only, DOM-based, idempotent. Never touches product data.
 * Usage: normalizePdpDetails(document) or normalizePdpDetails(someElement)
 */
(function (global) {
  'use strict';
  var SCOPE = '.x-block-description, [class*="x-block-collapsible-tab"]';
  var EXCLUDE = 'form, product-form, [class*="product-form"], [class*="guide"], [id*="guide"], [class*="personaliz"], [id*="personaliz"], [data-sj-no-normalize]';
  var HEADING_RE = /^(product\s+details|details|specifications)\s*:?$/i;
  var DONE = 'data-sj-details-normalized';

  function txt(n) { return (n.textContent || '').replace(/[\s\u00a0]+/g, ' ').trim(); }
  function isHeading(el) {
    if (!el || el.nodeType !== 1) return false;
    if (/^H[1-6]$/.test(el.tagName)) return true;
    // <p><strong>DETAILS</strong></p> style headings
    if (el.tagName === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) &&
        txt(el) === txt(el.children[0]) && txt(el).length < 40) return true;
    return false;
  }
  function isDetailsHeading(el) { return isHeading(el) && HEADING_RE.test(txt(el)); }
  function excluded(el, container) {
    if (el.querySelector && el.querySelector('form, input, select, textarea, button')) return true;
    var c = el.closest && el.closest(EXCLUDE);
    return !!(c && (container.contains(c) || c.contains(container)));
  }
  // Split a <p> into line groups by <br> (top-level only); returns array of node arrays.
  function lines(p) {
    var out = [[]];
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') out.push([]); else out[out.length - 1].push(n);
    });
    return out.filter(function (g) {
      return g.some(function (n) { return n.nodeType === 1 ? (n.tagName !== 'META' && txt(n)) : txt(n); });
    });
  }
  function startsWithLabel(group) {
    for (var i = 0; i < group.length; i++) {
      var n = group[i];
      if (n.nodeType === 3 && !txt(n)) continue;
      if (n.nodeType === 1 && n.tagName === 'META') continue;
      return n.nodeType === 1 && /^(STRONG|B)$/.test(n.tagName);
    }
    return false;
  }
  function isSpecParagraph(p) {
    if (p.tagName !== 'P') return false;
    var g = lines(p);
    if (!g.length) return false;
    if (g.length >= 2) return true;               // BR-delimited lines
    return startsWithLabel(g[0]) && /:/.test(txt(p)); // single "Label: value" line
  }
  function toList(p, doc) {
    var ul = doc.createElement('ul');
    ul.className = 'sj-pdp-specs';
    ul.setAttribute('data-sj-specs', 'converted');
    lines(p).forEach(function (g) {
      var li = doc.createElement('li');
      // trim leading/trailing whitespace-only text nodes
      while (g.length && g[0].nodeType === 3 && !txt(g[0])) g.shift();
      while (g.length && g[g.length - 1].nodeType === 3 && !txt(g[g.length - 1])) g.pop();
      g.forEach(function (n) { li.appendChild(n); });
      var lab = li.firstElementChild;
      if (lab && /^(STRONG|B)$/.test(lab.tagName) && li.firstChild === lab) lab.classList.add('sj-pdp-spec-label');
      ul.appendChild(li);
    });
    p.parentNode.replaceChild(ul, p);
    return ul;
  }

  function normalizeContainer(container) {
    var doc = container.ownerDocument;
    var changed = 0;
    var heads = Array.prototype.filter.call(container.querySelectorAll('h1,h2,h3,h4,h5,h6,p'), isDetailsHeading);
    heads.forEach(function (h) {
      if (excluded(h, container)) return;
      if (!h.classList.contains('sj-pdp-details-heading')) { h.classList.add('sj-pdp-details-heading'); changed++; }
      var n = h.nextElementSibling;
      while (n && !isHeading(n)) {
        var next = n.nextElementSibling;
        if (!excluded(n, container)) {
          if ((n.tagName === 'UL' || n.tagName === 'OL') && !n.classList.contains('sj-pdp-specs')) {
            n.classList.add('sj-pdp-specs'); changed++;
          } else if (isSpecParagraph(n)) { toList(n, doc); changed++; }
          // prose paragraphs and single-link paragraphs are left untouched
        }
        n = next;
      }
    });
    // Existing spec lists in descriptions without a heading: style only, keep semantics.
    Array.prototype.forEach.call(container.querySelectorAll('ul'), function (ul) {
      if (!ul.classList.contains('sj-pdp-specs') && !excluded(ul, container) && !ul.closest('nav')) {
        ul.classList.add('sj-pdp-specs'); changed++;
      }
    });
    container.setAttribute(DONE, '1');
    return changed;
  }

  function normalizePdpDetails(root) {
    root = root || (typeof document !== 'undefined' ? document : null);
    if (!root || !root.querySelectorAll) return 0;
    var list = Array.prototype.slice.call(root.querySelectorAll(SCOPE));
    if (root.nodeType === 1 && root.matches(SCOPE)) list.unshift(root);
    // only innermost-relevant content; skip excluded containers
    var total = 0;
    list.forEach(function (c) {
      var bad = c.closest(EXCLUDE);
      if (bad) return;
      total += normalizeContainer(c);
    });
    return total; // number of mutations; 0 on re-run (idempotent)
  }

  // Optional rerender-safe installer: debounced, ignores its own mutations.
  function installPdpDetailsNormalizer(root) {
    root = root || document;
    if (root.__sjDetailsObserver) return root.__sjDetailsObserver;
    var busy = false, queued = false, obs;
    function run() {
      queued = false; if (busy) return; busy = true;
      try { obs && obs.disconnect(); normalizePdpDetails(root); }
      finally { busy = false; obs && obs.observe(root.body || root, { childList: true, subtree: true }); }
    }
    run();
    if (typeof MutationObserver !== 'undefined') {
      obs = new MutationObserver(function () {
        if (busy || queued) return; queued = true;
        (global.requestAnimationFrame || setTimeout)(run);
      });
      obs.observe(root.body || root, { childList: true, subtree: true });
    }
    root.__sjDetailsObserver = obs;
    return obs;
  }

  global.normalizePdpDetails = normalizePdpDetails;
  global.installPdpDetailsNormalizer = installPdpDetailsNormalizer;
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalizePdpDetails: normalizePdpDetails, installPdpDetailsNormalizer: installPdpDetailsNormalizer };
})(typeof window !== 'undefined' ? window : globalThis);

if(document.querySelector('.sj-mariner-main')) installPdpDetailsNormalizer(document.querySelector('.sj-mariner-main'));
